import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function CodeRender({ node }) {
  const content = node.content || {};
  const code = content.code || '<!-- Eigenes HTML hier einfügen -->\n<div style="padding: 10px; border: 1px dashed red;">Mein Custom Code</div>';

  return (
    <div 
      style={{ width: '100%' }}
      dangerouslySetInnerHTML={{ __html: code }} 
    />
  );
}

registry.register('Code', {
  label: 'HTML / Code',
  icon: '🧑‍💻', 
  category: 'advanced', // oder basic
  component: CodeRender,
  
  defaultProps: {
    content: {
      code: '<!-- Eigenes HTML hier einfügen -->\n<div style="padding: 10px; border: 1px dashed red;">Mein Custom Code</div>'
    },
    style: {
      desktop: {
        marginBottom: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Custom HTML/JS/CSS',
          fields: [
            // Typ 'textarea' oder idealerweise ein echter Code-Editor
            { name: 'content.code', label: 'Quellcode eingeben', type: 'textarea' }
          ]
        }
      ]
    }
  ]
});
